import { ReactNode } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { SourceTag } from './SourceTag';

interface Props {
  label: string;
  value: ReactNode;
  source?: 'AUTO' | 'M365' | 'ASCORA';
}

const useStyles = makeStyles({
  wrap: {
    marginBottom: '12px',
  },
  label: {
    fontSize: '11px',
    color: tokens.colorNeutralForeground3,
    marginBottom: '6px',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  body: {
    backgroundColor: '#F4F7FB',
    borderRadius: '16px',
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: 'rgba(17,24,36,0.06)',
    borderRightColor: 'rgba(17,24,36,0.06)',
    borderBottomColor: 'rgba(17,24,36,0.06)',
    borderLeftColor: 'rgba(17,24,36,0.06)',
    paddingTop: '13px',
    paddingBottom: '13px',
    paddingLeft: '14px',
    paddingRight: '14px',
    fontSize: '15px',
    color: tokens.colorNeutralForeground1,
    minHeight: '52px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: '4px',
    columnGap: '6px',
    lineHeight: 1.4,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.56)',
  },
});

export function ReadOnlyField({ label, value, source }: Props) {
  const styles = useStyles();
  return (
    <div className={styles.wrap}>
      <div className={styles.label}>{label}</div>
      <div className={styles.body}>
        <span style={{ flex: 1, minWidth: 0 }}>{value}</span>
        {source && <SourceTag source={source} />}
      </div>
    </div>
  );
}
